import { makeAutoObservable } from 'mobx';

export type TagCondition = {
  includedTags: string[];
  excludedTags: string[];
  readonly empty: boolean;
  readonly tagString: string;
  readonly friendlyString: string;
  matches(tags?: string[]): boolean;
  matchCount(tags: string[]): number;
};

export function createTagCondition(json?: Partial<TagCondition>): TagCondition {
  return makeAutoObservable({
    includedTags: json?.includedTags || [],
    excludedTags: json?.excludedTags || [],

    get empty(): boolean {
      return this.includedTags.length === 0 && this.excludedTags.length === 0;
    },

    get tagString(): string {
      return this.includedTags.join(', ');
    },

    get friendlyString(): string {
      const included = this.includedTags.join(', ');
      const excluded = this.excludedTags.join(', ');
      if (this.includedTags.length > 0) {
        return this.excludedTags.length > 0 ? `${included} | ${excluded}` : included;
      }
      return this.excludedTags.length > 0 ? excluded : '<default>';
    },

    matches(tags?: string[]): boolean {
      if (tags) {
        return (
          (this.includedTags.length === 0 || this.includedTags.every((t) => tags.indexOf(t) !== -1)) &&
          !tags.some((t) => this.excludedTags.indexOf(t) !== -1)
        );
      }
      return true;
    },

    matchCount(tags: string[]): number {
      return this.includedTags.filter((v) => tags.includes(v)).length;
    },
  });
}
